var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uE80D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cadastro",
    transform: "translate(-710.000000, -419.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(290.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(30.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.16,105.68 C398.16,105.199998 398.279999,104.750002 398.52,104.33 C398.760001,103.909998 399.083331,103.580001 399.49,103.34 C399.896669,103.099999 400.339998,102.98 400.82,102.98 C401.300002,102.98 401.746665,103.103332 402.16,103.35 C402.573335,103.596668 402.903332,103.926665 403.15,104.34 C403.396668,104.753335 403.52,105.199998 403.52,105.68 C403.52,106.160002 403.400001,106.603331 403.16,107.01 C402.919999,107.416669 402.590002,107.739999 402.17,107.98 C401.749998,108.220001 401.300002,108.34 400.82,108.34 C400.339998,108.34 399.896669,108.220001 399.49,107.98 C399.083331,107.739999 398.760001,107.416669 398.52,107.01 C398.279999,106.603331 398.16,106.160002 398.16,105.68 Z M400.82,109.82 C401.580004,109.82 402.279997,109.636668 402.92,109.27 C403.560003,108.903332 404.066665,108.400003 404.44,107.76 C404.813335,107.119997 405,106.423337 405,105.67 C405,104.916663 404.813335,104.220003 404.44,103.58 C404.066665,102.939997 403.560003,102.433335 402.92,102.06 C402.279997,101.686665 401.583337,101.5 400.83,101.5 C400.076663,101.5 399.380003,101.686665 398.74,102.06 C398.099997,102.433335 397.596669,102.939997 397.23,103.58 C396.863332,104.220003 396.68,104.919996 396.68,105.68 C396.68,106.440004 396.863332,107.136663 397.23,107.77 C397.596669,108.403336 398.096663,108.903332 398.73,109.27 C399.363337,109.636668 400.059996,109.82 400.82,109.82 Z M395,102.32 L395,99.82 L397.5,99.82 L397.5,97.32 L403.32,97.32 L404.84,99 L407.5,99 C407.953336,99 408.346665,99.166665 408.68,99.5 C409.013335,99.833335 409.18,100.226664 409.18,100.68 L409.18,110.68 C409.18,111.133336 409.013335,111.519998 408.68,111.84 C408.346665,112.160002 407.953336,112.32 407.5,112.32 L394.18,112.32 C393.726664,112.32 393.333335,112.160002 393,111.84 C392.666665,111.519998 392.5,111.133336 392.5,110.68 L392.5,102.32 L395,102.32 Z M392.5,97.32 L392.5,94.82 L394.18,94.82 L394.18,97.32 L396.68,97.32 L396.68,99 L394.18,99 L394.18,101.5 L392.5,101.5 L392.5,99 L390,99 L390,97.32 L392.5,97.32 Z",
    id: "\\uE80D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.34fe2c6b0b9baa1d2558724cd03c6439.svg";
export { ForwardRef as ReactComponent };